import { object, string, number } from 'yup';
import { TFunction } from 'i18next';

export function makeFinancesSchema(t: TFunction) {
  return object().shape({
    a: string().required(t('form.required')),
    c: string().required(t('form.required')),
    d: string().required(t('form.required')),
    e: string().required(t('form.required')),
    f: object()
      .required()
      .default({})
      .shape({
        a: number().required(t('form.required')),
        b: number().required(t('form.required')),
        c: number().required(t('form.required')),
        d: number().required(t('form.required')),
        e: number().required(t('form.required')),
      })
      .test(
        '100% sum test',
        t('financesForm.f.sumError'),
        ({ a, b, c, d, e }) => Math.round((a + b + c + d + e) * 100) === 10_000,
      ),
  });
}
